import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Select from "react-select";
import { toast } from "react-toastify";
import { useFetchProfilesQuery } from "../../store/api/apiSlice";
import { Button, Input } from "../../ui";

const Updsteprofil = ({ signupMode = false, setStage, setStep }) => {
  const {
    data: profileData,
    error,
    isLoading,
    refetch,
  } = useFetchProfilesQuery();
  const [selectedAthletes, setSelectedAthletes] = useState(["", "", ""]);

  const [loading, setLoading] = useState(false);
  const [profile, setProfile] = useState({
    firstName: "",
    middleName: "",
    lastName: "",
    avatarName: "",
    email: "",
    memberid: "",
    phone: "",
    image: "",
    address: "",
    streetAddress: "",
    zip: "",
    city: "",
    state: "",
    school_name: "",
    referredBy: "",
    conference: "",
    shareMe: Boolean,
    interested_schools: [],
    favortite_sports_conference: [],
    favortite_athelete_conference: [],
    favorite_sports: [],
    favorite_athletes: [],
    interested_schools_Athelete: [],
  });

  const formatPhoneNumber = (value) => {
    const digits = value.replace(/\D/g, "");

    const limitedDigits = digits.slice(0, 10);
    const formatted = limitedDigits.replace(
      /(\d{3})(\d{3})(\d{4})/,
      "$1-$2-$3"
    );
    return formatted;
  };

  const firstNameRef = useRef();
  const middleNameRef = useRef();
  const lastNameRef = useRef();
  const avatarNameRef = useRef();
  const avatarRef = useRef();
  const phoneRef = useRef();
  const addressRef = useRef();
  const streetAddressRef = useRef();
  const schoolNameRef = useRef();
  const conferenceRef = useRef();
  const referredByRef = useRef();
  const memberRef = useRef(null);
  const cityRef = useRef();
  const stateRef = useRef();
  const zipRef = useRef();
  const passwordRef = useRef();
  const confirmPasswordRef = useRef();
  const [sportsOptions, setSportsOptions] = useState([[], [], []]);
  const [selectedSchoolsAthelete, setSelectedSchoolsAthelete] = useState(
    Array(3).fill("")
  );
  const [selectedSchools, setSelectedSchools] = useState(Array(3).fill(""));
  const [schools, setSchools] = useState([]);
  const [filteredSchools, setFilteredSchools] = useState([[], [], []]);
  const [filteredSchoolsConferences, setFilteredSchoolsConferences] = useState(
    []
  );
  const [conferences, setConferences] = useState("");
  const [selectedConferences, setSelectedConferences] = useState(
    Array(3).fill("")
  );
  const [selectedAtheleteConferences, setSelectedAtheleteConferences] =
    useState(Array(3).fill(""));
  const [selectedGenders, setSelectedGenders] = useState(Array(3).fill(""));
  const [filteredAtheleteSchools, setFilteredAtheleteSchools] = useState([
    [],
    [],
    [],
  ]);
  const [favSports, setFavSports] = useState([]);
  const [selectedSchool, setSelectedSchool] = useState("");
  const [avatarNameError, setAvatarNameError] = useState("");
  const [selectedFavoriteSports, setSelectedFavoriteSports] = useState(
    Array(3).fill("")
  );
  const secretKey = process.env.REACT_APP_SECRET_KEY;
  const baseUrl = process.env.REACT_APP_SERVER_URL;

  const navigate = useNavigate();

  useEffect(() => {
    if (profileData) {
      const {
        address = {},
        favorite_sports = [],
        interested_schools = [],
        interested_schools_Athelete = [],
        favorite_athletes = [],
      } = profileData.user;
      const { school_name } = profileData.user;
      setSelectedSchool({ value: school_name, label: school_name });

      const {
        fullAddress = "",
        city = "",
        zip = "",
        state = "",
        streetAddress = "",
      } = address;

      const favoriteSports = favorite_sports[0]
        ? JSON.parse(favorite_sports[0])
        : [];
      const favoriteAthelete = favorite_athletes[0]
        ? JSON.parse(favorite_athletes[0])
        : [];
      const interestedSchools =
        interested_schools[0] && interested_schools[0] !== "undefined"
          ? JSON.parse(interested_schools[0])
          : [];
      const interestedSchoolsAthelete =
        interested_schools_Athelete[0] &&
        interested_schools_Athelete[0] !== "undefined"
          ? JSON.parse(interested_schools_Athelete[0])
          : [];

      const initialSelectedSports = favoriteSports
        .map((athlete) => athlete.name)
        .slice(0, 3)
        .concat(Array(3).fill(""))
        .slice(0, 3);
      setSelectedFavoriteSports(initialSelectedSports);
      const initialsportconference = favoriteSports
        .map((athlete) => athlete.conference)
        .slice(0, 3)
        .concat(Array(3).fill(""))
        .slice(0, 3);
      setSelectedConferences(initialsportconference);
      const initialsportschool = favoriteSports
        .map((athlete) => athlete.school)
        .slice(0, 3)
        .concat(Array(3).fill(""))
        .slice(0, 3);
      setSelectedSchools(initialsportschool);
      const initialsportgender = favoriteSports
        .map((athlete) => athlete.gender)
        .slice(0, 3)
        .concat(Array(3).fill(""))
        .slice(0, 3);
      setSelectedGenders(initialsportgender);

      const initialSelectedAthletes = favoriteAthelete
        .map((athlete) => athlete.name)
        .slice(0, 3)
        .concat(Array(3).fill(""))
        .slice(0, 3);
      setSelectedAthletes(initialSelectedAthletes);
      const initialatheleteconference = favoriteAthelete
        .map((athlete) => athlete.conference)
        .slice(0, 3)
        .concat(Array(3).fill(""))
        .slice(0, 3);
      setSelectedAtheleteConferences(initialatheleteconference);
      const initialSelectedAthleteSchool = favoriteAthelete
        .map((athlete) => athlete.school)
        .slice(0, 3)
        .concat(Array(3).fill(""))
        .slice(0, 3);
      setSelectedSchoolsAthelete(initialSelectedAthleteSchool);

      setProfile({
        firstName: profileData.user.firstName || "alon",
        middleName: profileData.user.middleName || "alon",
        lastName: profileData.user.lastName || "musk",
        avatarName: profileData.user.avatarName || "RebYeller",
        email: profileData.user.email || "abc@cssfa.com",
        phone: profileData.user.phone || "662-292-2327",
        image: profileData.user.image,
        memberid: profileData.user.memberid,
        school_name: school_name,

        address: fullAddress,
        city: city,
        streetAddress: streetAddress,
        zip: zip,
        state: state,
        referredBy: profileData.user.referredBy,
      });

      localStorage.setItem("user", JSON.stringify(profileData.user.createdAt));
    }
  }, [profileData]);
  useEffect(() => {
    const fetchSchools = async () => {
      const xAuthToken = JSON.parse(localStorage.getItem("token"))?.token;

      try {
        const response = await fetch(`${baseUrl}/api/university/get-all`, {
          method: "GET",
          headers: {
            "secret-key": secretKey,
            "x-auth-token": xAuthToken,
          },
        });
        if (response.ok) {
          const data = await response.json();
          setSchools(data.university || []);
          setFilteredSchools([data.university || [], [], []]);
        } else {
        }
      } catch (error) {}
    };

    fetchSchools();
  }, []);

  useEffect(() => {
    const fetchFavSports = async () => {
      const xAuthToken = JSON.parse(localStorage.getItem("token"))?.token;

      try {
        const response = await fetch(`${baseUrl}/api/sports/get-all`, {
          method: "GET",
          headers: {
            "secret-key": secretKey,
            "x-auth-token": xAuthToken,
          },
        });
        if (response.ok) {
          const data = await response.json();
          setFavSports(data.sports || []);
        } else {
        }
      } catch (error) {}
    };

    fetchFavSports();
  }, []);

  const handleAthleteInputChange = (index, value) => {
    const updatedSelection = [...selectedAthletes];
    updatedSelection[index] = value;
    setSelectedAthletes(updatedSelection);
  };

  const handleAddSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);

    if (passwordRef.current?.value !== confirmPasswordRef.current?.value) {
      toast.error("Password and Confirm Password do not match.");
      setLoading(false);
      return;
    }
    const currentSelectedAthletes = [...selectedAthletes];

    const formData = new FormData();
    formData.append(
      "firstName",
      firstNameRef.current?.value || profile.firstName || ""
    );
    formData.append(
      "middleName",
      middleNameRef.current?.value || profile.middleName || ""
    );
    formData.append(
      "lastName",
      lastNameRef.current?.value || profile.lastName || ""
    );
    formData.append(
      "avatarName",
      avatarNameRef.current?.value || profile.avatarName || ""
    );
    formData.append(
      "memberid",
      memberRef.current?.value || profile.memberid || ""
    );
    formData.append("phone", phoneRef.current?.value || profile.phone || "");
    formData.append(
      "school_name",
      selectedSchool.value || profile.school_name || ""
    );
    formData.append("conference", conferences || profile.conference || "");
    const favoriteSportsData = selectedFavoriteSports.map((sport, index) => {
      return {
        name: sport,
        school: selectedSchools[index] || "No school available",
        conference: selectedConferences[index] || "No conference available",
        gender: selectedGenders[index] || "male",
      };
    });
    const favoriteAthletesData = selectedAthletes.map((athlete, index) => {
      return {
        name: athlete,
        school: selectedSchoolsAthelete[index] || "No school available",
        conference:
          selectedAtheleteConferences[index] || "No conference available",
      };
    });

    formData.append("favorite_athletes", JSON.stringify(favoriteAthletesData));

    formData.append("favorite_sports", JSON.stringify(favoriteSportsData));
    const favoriteAtheleteConference = selectedAtheleteConferences.filter(
      (conference) => conference
    );
    formData.append(
      "favortite_athelete_conference",
      JSON.stringify(favoriteAtheleteConference)
    );
    const favoriteSportConference = selectedConferences.filter(
      (conference) => conference
    );
    formData.append(
      "favortite_sports_conference",
      JSON.stringify(favoriteSportConference)
    );

    const validSelectedSchools = selectedSchools.filter((school) => school);
    formData.append(
      "interested_schools",
      JSON.stringify(
        validSelectedSchools.length > 0
          ? validSelectedSchools
          : profile.interested_schools
      )
    );
    const validSelectedSchoolsAthelete = selectedSchoolsAthelete.filter(
      (school) => school
    );
    formData.append(
      "interested_schools_Athelete",
      JSON.stringify(
        validSelectedSchoolsAthelete.length > 0
          ? validSelectedSchoolsAthelete
          : profile.interested_schools_Athelete
      )
    );

    formData.append(
      "referredBy",
      referredByRef.current?.value || profile.referredBy || ""
    );

    const address = {
      location: {
        longitude: profile.address?.location?.longitude || 10,
        latitude: profile.address?.location?.latitude || 110,
      },
      fullAddress:
        addressRef.current?.value || profile.address?.fullAddress || "",
      streetAddress:
        streetAddressRef.current?.value || profile.address?.streetAddress || "",
      city: cityRef.current?.value || profile.address?.city || "",
      state: stateRef.current?.value || profile.address?.state || "",
      zip: zipRef.current?.value || profile.address?.zip || "",
    };
    formData.append("address", JSON.stringify(address));
    const currentShareMeValue = profileData?.user.shareMe;
    formData.append("shareMe", !currentShareMeValue);
    if (passwordRef.current?.value) {
      formData.append("password", passwordRef.current.value);
    }
    if (confirmPasswordRef.current?.value) {
      formData.append("confirmPassword", confirmPasswordRef.current.value);
    }
    if (avatarRef.current?.files[0]) {
      formData.append("image", avatarRef.current.files[0]);
    }

    for (let [key, value] of formData.entries()) {
    }

    try {
      const token = JSON.parse(localStorage.getItem("token"));
      const xAuthToken = token ? token.token : null;

      const response = await fetch(`${baseUrl}/api/auth/update-profile`, {
        method: "PUT",
        headers: {
          "secret-key": secretKey,
          "x-auth-token": xAuthToken,
        },
        body: formData,
      });

      if (response.ok) {
        const result = await response.json();

        toast.success("Profile updated successfully");
        setLoading(false);
        if (!signupMode) {
          navigate("/");
        } else {
          if (setStage) {
            setStage("membership");
          } else if (setStep) {
            setStep(5);
          }
        }
      } else {
        const errorData = await response.json();

        toast.error(errorData.msg);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  };
  useEffect(() => {
    const updatedFilteredSchools = selectedConferences.map((conference) => {
      return schools.filter((school) => school.conference === conference);
    });
    setFilteredSchools(updatedFilteredSchools);
  }, [selectedConferences, schools]);
  useEffect(() => {
    const updatedFilteredSchools = selectedAtheleteConferences.map(
      (conference) => {
        return schools.filter((school) => school.conference === conference);
      }
    );
    setFilteredAtheleteSchools(updatedFilteredSchools);
  }, [selectedAtheleteConferences, schools]);
  const handleSchoolConferenceChange = (e) => {
    const selectedConf = e.target.value;

    setConferences(selectedConf);
    setProfile((prevProfile) => ({
      ...prevProfile,
      conference: selectedConf,
    }));

    const filtered = selectedConf
      ? schools.filter((school) => school.conference === selectedConf)
      : schools;

      const sortedFilteredSchools = 
      filtered.map((school) => ({
        value: school.name,
        label: school.common_name?school.common_name:school.name,
      })) 
      .sort((a, b) => a.label.localeCompare(b.label)); // Sort alphabetically by label

      setFilteredSchoolsConferences(sortedFilteredSchools || []); 
    console.log("filterd jhfjdsafjdshfjh", filtered);
  };
  const handleAtheleteConferenceChange = (index, e) => {
    const selectedConf = e.target.value;
    const updatedConferences = [...selectedAtheleteConferences];
    updatedConferences[index] = selectedConf;
    setSelectedAtheleteConferences(updatedConferences);

    const filtered = schools.filter(
      (school) => school.conference === selectedConf
    );
    const updatedFilteredSchools = [...filteredAtheleteSchools];
    updatedFilteredSchools[index] = filtered;
    setFilteredAtheleteSchools(updatedFilteredSchools);
  };
  const handleConferenceChange = (index, e) => {
    const selectedConf = e.target.value;
    const updatedConferences = [...selectedConferences];
    updatedConferences[index] = selectedConf;
    setSelectedConferences(updatedConferences);

    const filtered = schools.filter(
      (school) => school.conference === selectedConf
    );
    const updatedFilteredSchools = [...filteredSchools];
    updatedFilteredSchools[index] = filtered;
    setFilteredSchools(updatedFilteredSchools);
  };
  const handleSchoolSelectAthelete = async (index, schoolId) => {
    const selectedSchool = schools.find((school) => school.name === schoolId);
    if (selectedSchool) {
      const updatedSchools = [...selectedSchoolsAthelete];
      updatedSchools[index] = selectedSchool.name;
      setSelectedSchoolsAthelete(updatedSchools);
    }
  };
  const handleSchoolSelect = (index, schoolName) => {
    const updatedSchools = [...selectedSchools];
    updatedSchools[index] = schoolName;
    setSelectedSchools(updatedSchools);
  };
  const handleSchoolChange = (newValue) => {
    setSelectedSchool(newValue);
    console.log(newValue.value);
  };

  const handleAvatarNameChange = (e) => {
    const value = e.target.value;
    const avatarNameRegex = /^[a-zA-Z0-9]*$/;

    if (!avatarNameRegex.test(value)) {
      setAvatarNameError(
        "Avatar Name must be alphanumeric and cannot contain spaces or special characters."
      );
    } else {
      setAvatarNameError("");
    }

    e.target.value = value.replace(/[^a-zA-Z0-9]/g, "");
  };
  const handlePhoneChange = (event) => {
    const inputValue = event.target.value;
    const formattedValue = formatPhoneNumber(inputValue);
    phoneRef.current.value = formattedValue;
  };

  const handleSportSelect = (index, sport) => {
    const updatedSports = [...selectedFavoriteSports];
    updatedSports[index] = sport;
    setSelectedFavoriteSports(updatedSports);
    const selectedSport = favSports.find((s) => s.name === sport);
    if (selectedSport) {
      const conferences = selectedSport.conferences || [];
      const updatedConferences = [...selectedConferences];
      updatedConferences[index] = conferences[0] || "";
      setSelectedConferences(updatedConferences);
    }
  };

  const [image, setImage] = useState(null);

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImage(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  return (
    <div className="profileUpdateForm pt-3 pb-4" style={{ overflow: "hidden" }}>
      <div
        style={{
          float: "right",
          marginLeft: "auto",
          borderRadius: "50px",
          paddingRight: "20px",
        }}
      >
        <Link
          style={{ borderRadius: "50px" }}
          to="/"
          className="btn btn-secondary ml-2 "
        >
          <FontAwesomeIcon icon={faTimes} /> {/* Cross icon */}
        </Link>
      </div>

      <form onSubmit={handleAddSubmit} className="col-10 mx-auto ">
        <div className="title-section mb-4">
          <h2 className="pb-0">Update Profile</h2>
        </div>

        {!signupMode && (
          <>
            <div className="update-content d-flex flex-column membership_div">
              <h4>Membership</h4>
              <div
                className="d-flex align-items-end update_profile_button"
                style={{ gap: "10px", marginBottom: "10px" }}
              >
                <h6 style={{ textAlign: "center" }}>
                  {profileData?.user.isPaid
                    ? `Your current membership is ${profileData?.user?.payment?.package_name}. `
                    : "You currently doesnot have a membership. "}
                </h6>
                <Button
                  onClick={() => navigate("/membership")}
                  style={{ height: "max-content", width: "fit-content" }}
                >
                  {" "}
                  {profileData?.user.isPaid
                    ? "Check Details"
                    : "Get Membership"}
                </Button>
              </div>
            </div>
          </>
        )}
        <div className="profile-main d-flex justify-content-between row pt-4">
          <div className="profile-container col-3">
            <img
              style={{
                objectFit: "cover",
                width: "100px",
                height: "100px",
                borderRadius: "50%",
              }}
              src={image ? image : `${baseUrl}/${profile.image}`}
              alt={profile.avatarName}
              className="profile-image"
            />
            <div className="button-container" style={{ marginTop: "20px" }}>
              <input
                type="file"
                id="avatar"
                ref={avatarRef}
                accept="image/*"
                style={{ display: "none" }}
                onChange={handleImageChange}
              />
              <label
                htmlFor="avatar"
                className="button change-button"
                style={{
                  padding: "10px 20px",
                  margin: "5px",
                  border: "none",
                  borderRadius: "5px",
                  cursor: "pointer",
                  backgroundColor: "#2c3e50",
                  color: "white",
                  display: "ruby-text",
                }}
              >
                Change picture
              </label>
            </div>
          </div>
          {!signupMode && (
            <>
              <p className="fieldWrapper2 col-3">
                <Input
                  placeholder="First Name"
                  label="First Name"
                  type="text"
                  defaultValue={profile.firstName}
                  ref={firstNameRef}
                />
              </p>
              <p className="fieldWrapper2 col-3 pt_top">
                <Input
                  placeholder="Middle Name"
                  label="Middle Name  "
                  type="text"
                  defaultValue={profile.middleName}
                  ref={middleNameRef}
                />
              </p>
              <p className="fieldWrapper2 col-3 pt_top">
                <Input
                  placeholder="Last Name"
                  label="Last Name"
                  type="text"
                  defaultValue={profile.lastName}
                  ref={lastNameRef}
                />
              </p>
            </>
          )}
        </div>

        <div className="profile-main d-flex justify-content-between row pt-4">
          <p className="fieldWrapper2 col-3">
            <Input
              placeholder="Avatar Name"
              label="Avatar Name"
              type="text"
              defaultValue={profile.avatarName}
              ref={avatarNameRef}
              onChange={handleAvatarNameChange}
            />
            {avatarNameError && (
              <span className="text-danger">{avatarNameError}</span>
            )}
          </p>

          <p
            className=" d-flex  fieldWrapper2 col-3 pt_top "
            style={{ display: profile.firstName ? "none" : "block" }}
          >
            <Input
              placeholder="Email"
              label="Email"
              type="text"
              defaultValue={profile.email}
              disabled
            />
          </p>
          <p
            className={`d-flex  fieldWrapper2 pt_top ${
              signupMode ? "col-3" : "col-3 "
            } ${signupMode ? "pt-4" : ""}`}
          >
            <Input
              placeholder="Member #"
              label="Member #"
              type="text"
              defaultValue={profile.memberid}
              ref={memberRef}
              disabled
            />
          </p>
          <p
            className={`d-flex  fieldWrapper2 pt_top ${
              signupMode ? "col-3" : "col-3 "
            } ${signupMode ? "pt-4" : ""}`}
          >
            <Input
              placeholder="123-456-7890"
              label="Phone"
              type="tel"
              defaultValue={profile.phone}
              ref={phoneRef}
              onChange={handlePhoneChange}
            />
          </p>
        </div>

        <div
          className={`profile-main  d-flex justify-content-between row ${
            signupMode ? "pt-4" : "pt-4"
          }`}
        >
          <p className="fieldWrapper2 col-3">
            <Input
              label="Street Address"
              type="text"
              placeholder="Street Address"
              id="streetAddress"
              defaultValue={profile?.streetAddress}
              ref={streetAddressRef}
            />
          </p>
          <p className="fieldWrapper2 col-3 pt_top">
            <Input
              placeholder="City"
              label="City"
              type="text"
              id="city"
              defaultValue={profile?.city}
              ref={cityRef}
            />
          </p>
          <p className="fieldWrapper2 col-3 pt_top">
            <Input
              placeholder="State"
              label="State"
              type="text"
              id="state"
              defaultValue={profile?.state}
              ref={stateRef}
            />
          </p>
          <p className="fieldWrapper2 col-3 pt_top">
            <Input
              placeholder="Zip"
              label="Zip"
              type="text"
              id="zip"
              defaultValue={profile?.zip}
              ref={zipRef}
            />
          </p>
        </div>

        <div className="d-flex justify-content-between row pt-4 signup_conference">
          <p className="fieldWrapper2 my_college_field">
            <label htmlFor="Favorite College" className="form-labels">
              Conference
            </label>
            <select
              id="conference"
              ref={conferenceRef}
              onChange={handleSchoolConferenceChange}
              className="form-select"
              style={{ color: "gray" }}
            >
              <option value="">Select a Conference</option>
              {Array.from(
                new Set(schools.map((school) => school.conference))
              ).map((conference, index) => (
                <option key={index} value={conference}>
                  {conference}
                </option>
              ))}
            </select>
          </p>
          <p className="fieldWrapper21 my_college_field">
            <label htmlFor="Favorite College" className="form-labels">
              My College
            </label>
            <Select
              options={filteredSchoolsConferences}
              placeholder="Select School"
              value={selectedSchool}
              ref={schoolNameRef}
              onChange={handleSchoolChange}
              styles={{
                container: (base) => ({ ...base, borderRadius: "5px" }),
              }}
            />
          </p>
        </div>
        <div className=" profile-main d-flex justify-content-between row pt-4">
          {!signupMode && (
            <>
              <div className="update-content ">
                <h4>Change Password</h4>
              </div>
              <p
                className="d-flex fieldWrapper2 col-6  pt-4"
                style={{ display: profile.firstName ? "none" : "block" }}
              >
                <Input
                  placeholder="Password"
                  label="Password"
                  type="password"
                  id="password"
                  ref={passwordRef}
                />
              </p>
              <p
                className="d-flex fieldWrapper2 col-6  pt-4"
                style={{ display: profile.firstName ? "none" : "block" }}
              >
                <Input
                  placeholder="Confirm Password"
                  label="Confirm Password"
                  type="password"
                  id="confirmPassword"
                  ref={confirmPasswordRef}
                />
              </p>{" "}
            </>
          )}
        </div>

        <div className="update-content pt-4">
          <h4>
            3 Sports and the Associated College of that Sport I would like to
            Follow
          </h4>
        </div>
        <div className="d-flex justify-content-between row pt-4">
          {[0, 1, 2].map((index) => (
            <div className="Selector_container" key={index}>
              <div style={{ flex: 1, maxWidth: "100%" }}>
                <label style={{ whiteSpace: "nowrap" }}>
                  Favorite Sport {index + 1}
                </label>
                <select
                  value={selectedFavoriteSports[index]}
                  onChange={(e) => handleSportSelect(index, e.target.value)}
                  className="form-select"
                  style={{ color: "gray" }}
                >
                  <option value="">Select favorite sports</option>

                  {favSports.map((sport) => (
                    <option key={sport._id} value={sport.name}>
                      {sport.name}
                    </option>
                  ))}
                </select>
              </div>
              <div style={{ flex: 1, maxWidth: "100%" }}>
                <label style={{ whiteSpace: "nowrap" }}>
                  Favorite Conference {index + 1}
                </label>
                <select
                  value={selectedConferences[index]}
                  onChange={(e) => handleConferenceChange(index, e)}
                  className="form-select"
                  style={{ color: "gray" }}
                >
                  <option value="">Select Conference</option>

                  {Array.from(
                    new Set(schools.map((school) => school.conference))
                  ).map((conference, index) => (
                    <option key={index} value={conference}>
                      {conference}
                    </option>
                  ))}
                </select>
              </div>
              <div style={{ flex: 1, maxWidth: "100%" }}>
                <label style={{ whiteSpace: "nowrap" }}>
                  Favorite College {index + 1}
                </label>
                <select
                  value={selectedSchools[index]}
                  onChange={(e) => handleSchoolSelect(index, e.target.value)}
                  className="form-select mb-2"
                  style={{ color: "gray" }}
                >
                  <option value="">Select School</option>
                  {Array.isArray(filteredSchools[index]) &&
                    filteredSchools[index]
                    .slice() 
                    .sort((a, b) => {
                      const nameA = a.common_name || a.name;
                      const nameB = b.common_name || b.name;
                      return nameA.localeCompare(nameB); 
                    }).map((school) => (
                      <option
                        key={school._id}
                        value={school.name}
                        style={{
                          maxWidth: "100%",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {school.common_name?school.common_name:school.name}
                      </option>
                    ))}
                </select>
              </div>
              <div style={{ flex: 1, maxWidth: "100%" }}>
                <label style={{ whiteSpace: "nowrap" }}>Gender </label>
                <select
                  placeholder="Gender"
                  name="Gender"
                  className="form-select mb-2"
                  value={selectedGenders[index] || "male"}
                  onChange={(e) => {
                    const newGenders = [...selectedGenders];
                    newGenders[index] = e.target.value;
                    setSelectedGenders(newGenders);
                  }}
                  style={{ color: "gray" }}
                >
                  <option value="male">Male</option>
                  <option value="female">Female</option>
                  <option value="Any">Any</option>
                </select>
              </div>
            </div>
          ))}
          <div className="update-content ">
            <h4>
              3 athletes and the associated College of that athlete I would like
              to follow
            </h4>
          </div>
          <div className="pt-4"></div>
          {[0, 1, 2].map((index) => (
            <div className="Selector_container" key={index}>
              <div key={index} style={{ flex: 1, maxWidth: "100%" }}>
                <label>Favorite Athlete {index + 1}</label>
                <input
                  type="text"
                  value={selectedAthletes[index]}
                  onChange={(e) =>
                    handleAthleteInputChange(index, e.target.value)
                  }
                  className="form-input"
                  style={{ width: "100%", color: "gray", height: "52%" }}
                  placeholder="Enter athlete's name"
                />
              </div>
              <div style={{ flex: 1, maxWidth: "100%" }}>
                <label>Favorite Conference {index + 1}</label>
                <select
                  value={selectedAtheleteConferences[index]}
                  onChange={(e) => handleAtheleteConferenceChange(index, e)}
                  className="form-select"
                  style={{ color: "gray" }}
                >
                  <option value="">Select Conference</option>
                  {Array.from(
                    new Set(schools.map((school) => school.conference))
                  ).map((conference, index) => (
                    <option key={index} value={conference}>
                      {conference}
                    </option>
                  ))}
                </select>
              </div>
              <div style={{ flex: 1, maxWidth: "100%" }}>
                <label>Favorite College {index + 1}</label>
                <select
                  value={selectedSchoolsAthelete[index]}
                  onChange={(e) =>
                    handleSchoolSelectAthelete(index, e.target.value)
                  }
                  className="form-select mb-2"
                  style={{ color: "gray" }}
                >
                  <option value="">Select School</option>
                  {filteredAtheleteSchools[index]
                  .slice() 
                  .sort((a, b) => {
                    const nameA = a.common_name || a.name;
                    const nameB = b.common_name || b.name;
                    return nameA.localeCompare(nameB); 
                  }).map((school) => (
                    <option
                      key={school._id}
                      value={school.name}
                      style={{
                        maxWidth: "100%",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {school.common_name?school.common_name:school.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          ))}
        </div>

        <div className="d-flex justify-content-between row">
          <p
            className="fieldWrapper2 col-6"
            style={{ display: profile.lastName ? "none" : "block" }}
          >
            <Input
              placeholder="Referred By"
              label="Referred By"
              type="text"
              id="referredBy"
              defaultValue={profile.referredBy}
              ref={referredByRef}
            />
          </p>
        </div>

        <div className="d-flex  justify-content-center" style={{ gap: "14px" }}>
          <Button
            style={{ marginRight: "10px", width: "fit-content" }}
            type="submit"
            className="btn btn-primary mx-2"
            loading={loading}
          >
            Update
          </Button>
        </div>
      </form>
    </div>
  );
};

export default Updsteprofil;
